// extracted by mini-css-extract-plugin
export var phone = "_1j-0";